
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recruiter/partnerships",
      function () {
        return require("private-next-pages/recruiter/partnerships/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recruiter/partnerships"])
      });
    }
  